<template>
	<div class="setbaojia">
		<div style="text-align: center;">
			<el-form :inline="true" size="mini" style="padding-left:10px" label-width="80">
				<el-form-item :label="showbaojia_lang.type">
					<el-select v-model="info.type" style="width:150px" @change="searchbaojia" >
						<el-option v-for="item in typeoptions"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="showbaojia_lang.endport" v-if="info.type=='空运'">
					<el-select v-model="info.endport" style="width:150px" @change="searchbaojia" :filterable="true" :clearable="true">
						<el-option v-for="item in portlist"  :key="item.label"  :label="item.label" :value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="baojialist.length>0">
					<span>{{baojialist.length}}{{showbaojia_lang.counttips}}</span>
				</el-form-item>
			</el-form>
		</div>
		<el-divider></el-divider>
		<div :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<div v-for="(item,index) in baojialist" :key="index" v-if="baojialist.length>0">
				<setbaojia :ref="'setbaojia_'+index" :isdetail="true" :item="item"></setbaojia>
				<el-divider v-if="index!=(baojialist.length-1)"></el-divider>
			</div>
		</div>
	</div>
</template>
<script>
import setbaojia from '@/pages/transport/set_baojia.vue';//报价信息
import Utils from '../../lib/util.js';
export default {
	components: {
		setbaojia
	},
	props: {
		
	},
	data() {
		return {
			windowHeight: window.innerHeight - 220,
			info:{
				endport:'',
				type:''
			},
			portlist:[],
			showbaojia_lang:{},
			typeoptions:[{value:'空运'},{value:'海运清关费'},{value:'空运清关费'},{value:'快递电商'}],
			baojialist:[]
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/cw/setbaojia.scss');
		this.init();
	},
	methods:{
		init(){
			this.loadlanguage();
			this.loadportlist();
		},
		loadportlist(){
			var that=this;
			this.$apipost.get.dic({type:'港口'}).then(res=>{
				if(res.list!=undefined){
					that.portlist=res.list;
				}
			});
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('showbaojia',this).then(res=>{
				if(res.state=='1')
					that.showbaojia_lang=that.$lang.label.showbaojia;
			});
		},
		searchbaojia(){
			//debugger
			//查询结果
			// var list=[{row:{c_id:'fb7ab48f-98c1-43df-8597-ae63dc5c0008',endport:this.info.endport,type:this.info.type}},{row:{c_id:'734484fa-3f74-423f-80e8-d5236cd20e65',endport:this.info.endport,type:this.info.type}}]
			var that=this;
			this.baojialist=[];
			if(this.info.type=='')
				return false;
			else if(this.info.type=='空运'&&this.info.endport=='')
				return false;
			if(this.info.type!='空运')
				this.info.endport='';
			var paraminfo={
				type:this.info.type,
				endport:this.info.endport
			}
			//debugger
			this.$apipost.get.getbaojialist({paraminfo:paraminfo}).then(res=>{
				if(res.state=='1'){
					var list=[];
					res.list.forEach(e=>{
						list.push({row:e});
					});
					that.baojialist=list;
					this.$nextTick(function(){
						//debugger
						for(var i=0;i<this.baojialist.length;i++)
							this.$refs['setbaojia_'+i][0].init();
					});
				}else
					this.$tool.message(that.showbaojia_lang.nobaojia, 0);
			});			
		}
	}
}
</script>
<style>
</style>